/**
 * The display mode for the Dropdown component.
 */
export var DropdownMode;
(function (DropdownMode) {
    DropdownMode["Normal"] = "Normal";
    DropdownMode["Inline"] = "Inline";
})(DropdownMode || (DropdownMode = {}));
